import type { TasksKanbanCustomer } from '@ts-tasks-kanban/interfaces'

import { useTasksKanbanStore } from '@stores/tasks-kanban'
import { useCommonStore } from '@stores/common'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

import { getAxiosErrorMessage } from '@helpers/axios'

import { useToast } from '@UI/Toast/ToastProvider'

interface KanbanTaskCreateApiOptions {
  customer_id: number | string
}

interface KanbanTaskCreateResponse {
  customer: TasksKanbanCustomer
}

export const useKanbanTaskCreateApi = async (
  options: KanbanTaskCreateApiOptions,
): Promise<KanbanTaskCreateResponse | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const commonStore = useCommonStore()
  const tasksKanbanStore = useTasksKanbanStore()

  const url = useAdminRoutes('admin.kanban-tasks.create', { customer_id: options.customer_id })

  commonStore.setLoading(true)

  try {
    const { data } = await $axios.get(url!)
    const response: KanbanTaskCreateResponse = data.data

    tasksKanbanStore.setCustomer(response.customer)
    commonStore.setLoading(false)

    return response
  } catch (err: unknown) {
    console.error(err)
    toast.error(getAxiosErrorMessage(err))
    commonStore.setLoading(false)

    return null
  }
}
